module.exports = __webpack_public_path__ + "img/selected6-min.35197a35.png";